import request from "../request";

export const getBranches = async () => {
	const response = await request({
		url: `api/github/branches`,
	});

	return response.data;
};

export const getGitTags = async () => {
	const response = await request({
		url: `api/github/tags`,
	});

	return response.data;
};
